import { Link, useSearchParams } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { SearchResultItem } from '@shared/schemas';
import { Highlight } from './highlight';
import { Badge } from '@/components/ui/badge';
import { cn, formatDateIt } from '@/lib/utils';
import { toFindQuery } from '@/lib/find';

export function ArticleCard({ item, actions }: { item: SearchResultItem; actions?: ReactNode }) {
  const [searchParams] = useSearchParams();
  // Riporta i termini cercati nell'articolo così l'evidenziazione continua.
  const find = toFindQuery({
    q: searchParams.get('q'),
    testo: searchParams.get('testo'),
    titolo: searchParams.get('titolo'),
    quaderni: searchParams.get('quaderni'),
  });
  const to = find ? `/articoli/${item.id}?find=${encodeURIComponent(find)}` : `/articoli/${item.id}`;

  return (
    <article className="relative border-b border-(--color-border) py-5">
      <Link to={to} className="block group">
        <h3 className={cn('font-serif text-xl font-semibold leading-snug group-hover:underline', actions && 'pr-20')}>
          <Highlight html={item.titoloHl} />
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-(--color-muted-foreground)">
          <time dateTime={item.data}>{formatDateIt(item.data)}</time>
          <Badge variant="outline" className="font-normal">
            {item.fonte}
          </Badge>
        </div>
        <p className="mt-2.5 text-sm leading-relaxed text-(--color-foreground)/85 line-clamp-3">
          <Highlight html={item.snippet} />
        </p>
      </Link>
      {actions && <div className="absolute right-0 top-5 flex items-center gap-0.5">{actions}</div>}
    </article>
  );
}
